export default {
	loading: "Carregando agenda...",
	unavailable: "Agenda indisponível",
	unavailableHint:
		"Este link pode ter expirado ou a agenda foi desativada pelo templo.",
	empty: "Nenhum ritual publicado no momento.",
	upcoming: "Próximos rituais",
	tabs: {
		calendar: "Calendário",
		info: "Mais informações",
	},
	info: {
		about: "Sobre a casa",
		address: "Endereço",
		contact: "Contato",
		phone: "Telefone",
		whatsapp: "WhatsApp",
		email: "E-mail",
		social: "Redes sociais",
	},
	reserve: "Reservar presença",
	full: "Lotado",
	dialog: {
		title: "Reservar presença",
		subtitle: "Preencha seus dados para reservar neste ritual.",
		name: "Seu nome",
		phone: "Telefone",
		email: "E-mail",
		notes: "Observação (opcional)",
		photo: {
			label: "Foto",
			capture: "Tirar foto",
			retake: "Tirar outra",
		},
		consent: "Autorizo o templo a usar meus dados de contato para esta reserva.",
		consentWithPhoto:
			"Autorizo o templo a usar meus dados de contato e a foto tirada agora para esta reserva.",
		submit: "Enviar reserva",
		cancel: "Cancelar",
	},
	validation: {
		nameRequired: "Informe seu nome",
		phoneRequired: "Informe seu telefone",
		emailRequired: "Informe seu e-mail",
		emailInvalid: "E-mail inválido",
		consentRequired: "É necessário autorizar para reservar",
		photoRequired: "Tire uma foto para concluir a reserva",
	},
	success: {
		title: "Reserva recebida!",
		message: "Recebemos sua reserva. O templo vai analisar e retornar o contato.",
		close: "Fechar",
	},
	error: "Não foi possível enviar sua reserva. Tente novamente.",
	poweredBy: "Agenda por ORI",
	tracking: {
		title: "Sua reserva",
		statusPendingConfirmation: "Confirme sua reserva",
		statusPendingReview: "Aguardando análise do templo",
		statusApproved: "Reserva confirmada",
		statusRejected: "Reserva recusada",
		statusCancelled: "Reserva cancelada",
		confirmHint: "Clique abaixo para confirmar sua presença neste ritual.",
		reviewHint: "Recebemos sua confirmação. O templo vai analisar e entrar em contato.",
		approvedHint: "Tudo certo! Sua presença está confirmada.",
		confirm: "Confirmar reserva",
		cancel: "Cancelar reserva",
		confirmed: "Reserva confirmada!",
		cancelled: "Reserva cancelada.",
		error: "Não foi possível concluir. Tente novamente.",
		notFound: "Reserva não encontrada.",
	},
};
